module.exports = __webpack_public_path__ + "img/eye-icon.e4049bd0.svg";